// import React from 'react';

// const Pricing = () => {
//   return (
//     <section className="py-16 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         <h1 className="text-4xl font-bold text-center mb-12 text-yellow-600">Cennik</h1>
        
//         {/* Apartamenty DeLuxe */}
//         <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
//           <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
//             Apartamenty Kolorowe Domki 4-8 osobowe
//           </h2>
          
//           <div className="overflow-x-auto mb-8">
//             <table className="w-full border-collapse">
//               <thead>
//                 <tr className="bg-yellow-50">
//                   <th className="p-4 text-left border-b border-yellow-200">Termin</th>
//                   <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">01.05.2025 - 04.05.2025</td>
//                   <td className="p-4 text-right font-medium">400 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">05.05.2025 - 27.06.2025</td>
//                   <td className="p-4 text-right font-medium">270 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">28.06.2025 - 11.07.2025</td>
//                   <td className="p-4 text-right font-medium">450 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">12.07.2025 - 17.08.2025</td>
//                   <td className="p-4 text-right font-medium">500 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">18.08.2025 - 31.08.2025</td>
//                   <td className="p-4 text-right font-medium">450 PLN</td>
//                 </tr>
//                 <tr className="hover:bg-gray-50">
//                   <td className="p-4">01.09.2025 - 30.09.2025</td>
//                   <td className="p-4 text-right font-medium">270 PLN</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div className="space-y-4 text-gray-700">
//             <p className="font-medium">Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.</p>
//             <p>Pobyt Boże Ciało cena <span className="font-medium">400 PLN/doba</span>. Pobyty krótsze wyceniamy indywidualnie.</p>
//             <p>Każda dodatkowa osoba w Apartamecie za dopłatą <span className="font-medium">50 PLN/doba</span>. Maksymalna ilość osób wynosi <span className="font-medium">8</span> (razem z dziećmi).</p>
//             <p>Opłata za małe zwierzęta (psy i koty) wynosi <span className="font-medium">20 PLN/doba</span>.</p>
            
//             <div className="mt-6 space-y-2">
//               <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
//               <ul className="list-disc pl-5 space-y-1">
//                 <li>Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną i miejsce parkingowe.</li>
//                 <li>Ceny nie zawierają opłaty za ewentualne ogrzewanie elektryczne – płatność za rzeczywiste zużycie według wskazań licznika.</li>
//               </ul>
//             </div>

//             <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
//               <p>Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail.</p>
//               <p>Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.</p>
//             </div>

//             <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
//               <p className="font-medium">Wynajem Domków Urszula Drużna</p>
//               <p>Numer rachunku: <span className="font-mono">70 1050 1924 1000 0092 3962 2898</span></p>
//               <p>W tytule przelewu proszę wpisać: <span className="font-medium">Imię i Nazwisko, termin pobytu i numer telefonu</span></p>
//             </div>
//           </div>
//         </div>

//         {/* Kolorowe Domki */}
//         <div className="bg-white rounded-xl shadow-lg p-8">
//           <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
//             Kolorowe Domki 4-6 osobowe
//           </h2>
          
//           <div className="overflow-x-auto mb-8">
//             <table className="w-full border-collapse">
//               <thead>
//                 <tr className="bg-yellow-50">
//                   <th className="p-4 text-left border-b border-yellow-200">Termin</th>
//                   <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">01.06.2025 - 27.06.2025</td>
//                   <td className="p-4 text-right font-medium">200 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">28.06.2025 - 11.07.2025</td>
//                   <td className="p-4 text-right font-medium">350 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">12.07.2025 - 17.08.2025</td>
//                   <td className="p-4 text-right font-medium">400 PLN</td>
//                 </tr>
//                 <tr className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">18.08.2025 - 31.08.2025</td>
//                   <td className="p-4 text-right font-medium">350 PLN</td>
//                 </tr>
//                 <tr className="hover:bg-gray-50">
//                   <td className="p-4">01.09.2025 - 30.09.2025</td>
//                   <td className="p-4 text-right font-medium">200 PLN</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div className="space-y-4 text-gray-700">
//             <p className="font-medium">Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.</p>
//             <p>Pobyty krótsze oraz na Boże Ciało (<span className="font-medium">300 PLN/doba</span>) wyceniamy indywidualnie.</p>
//             <p>Każda dodatkowa osoba w domku za dopłatą <span className="font-medium">30 PLN/doba</span>. Maksymalna ilość osób wynosi <span className="font-medium">6</span> (2 osoby dorosłe i reszta dzieci).</p>
//             <p>Opłata za małe zwierzęta (psy i koty) wynosi <span className="font-medium">20 PLN/doba</span>.</p>
            
//             <div className="mt-6 space-y-2">
//               <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
//               <ul className="list-disc pl-5 space-y-1">
//                 <li>Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną oraz miejsce parkingowe.</li>
//               </ul>
//             </div>

//             <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
//               <p>Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail.</p>
//               <p>Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.</p>
//             </div>

//             <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
//               <p className="font-medium">Irena Drużna</p>
//               <p>Numer rachunku: <span className="font-mono">17 1050 1041 1000 0092 0616 4031</span></p>
//               <p>W tytule przelewu proszę wpisać: <span className="font-medium">Imię i Nazwisko, termin pobytu i numer telefonu</span></p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Pricing;

// import React, { useState, useEffect } from 'react';

// const Pricing = () => {
//   const [pricingData, setPricingData] = useState({
//     title: "Cennik",
//     apartamenty: {
//       title: "Apartamenty Kolorowe Domki 4-8 osobowe",
//       table: [
//         { term: "01.05.2025 - 04.05.2025", price: "400 PLN" },
//         { term: "05.05.2025 - 27.06.2025", price: "270 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "450 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "500 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "450 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "270 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyt Boże Ciało cena 400 PLN/doba. Pobyty krótsze wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w Apartamecie za dopłatą 50 PLN/doba. Maksymalna ilość osób wynosi 8 (razem z dziećmi).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną i miejsce parkingowe.",
//         "Ceny nie zawierają opłaty za ewentualne ogrzewanie elektryczne – płatność za rzeczywiste zużycie według wskazań licznika."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Wynajem Domków Urszula Drużna",
//         numerRachunku: "70 1050 1924 1000 0092 3962 2898",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     },
//     domki: {
//       title: "Kolorowe Domki 4-6 osobowe",
//       table: [
//         { term: "01.06.2025 - 27.06.2025", price: "200 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "350 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "400 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "350 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "200 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyty krótsze oraz na Boże Ciało (300 PLN/doba) wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w domku za dopłatą 30 PLN/doba. Maksymalna ilość osób wynosi 6 (2 osoby dorosłe i reszta dzieci).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną oraz miejsce parkingowe."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Irena Drużna",
//         numerRachunku: "17 1050 1041 1000 0092 0616 4031",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     }
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('pricingData');
//     if (savedData) {
//       try {
//         setPricingData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych cennika:', error);
//       }
//     }
//   }, []);

//   const renderPricingSection = (section) => (
//     <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
//       <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
//         {section.title}
//       </h2>
      
//       <div className="overflow-x-auto mb-8">
//         <table className="w-full border-collapse">
//           <thead>
//             <tr className="bg-yellow-50">
//               <th className="p-4 text-left border-b border-yellow-200">Termin</th>
//               <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
//             </tr>
//           </thead>
//           <tbody>
//             {section.table.map((row, index) => (
//               <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
//                 <td className="p-4">{row.term}</td>
//                 <td className="p-4 text-right font-medium">{row.price}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="space-y-4 text-gray-700">
//         {section.notes.map((note, index) => (
//           <p key={index}>{note}</p>
//         ))}
        
//         <div className="mt-6 space-y-2">
//           <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
//           <ul className="list-disc pl-5 space-y-1">
//             {section.uwagi.map((uwaga, index) => (
//               <li key={index}>{uwaga}</li>
//             ))}
//           </ul>
//         </div>

//         <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
//           <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
//           <p>{section.warunki}</p>
//         </div>

//         <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
//           <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
//           <p className="font-medium">{section.danePrzelewowe.nazwa}</p>
//           <p>Numer rachunku: <span className="font-mono">{section.danePrzelewowe.numerRachunku}</span></p>
//           <p>W tytule przelewu proszę wpisać: <span className="font-medium">{section.danePrzelewowe.tytulPrzelewu}</span></p>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <section className="py-16 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         <h1 className="text-4xl font-bold text-center mb-12 text-yellow-600">{pricingData.title}</h1>
        
//         {renderPricingSection(pricingData.apartamenty)}
//         {renderPricingSection(pricingData.domki)}
//       </div>
//     </section>
//   );
// };

// export default Pricing;

// import React, { useState, useEffect } from 'react';

// const Pricing = () => {
//   const API_BASE = 'http://localhost/api';
  
//   const [pricingData, setPricingData] = useState({
//     title: "Cennik",
//     apartamenty: {
//       title: "Apartamenty Kolorowe Domki 4-8 osobowe",
//       table: [
//         { term: "01.05.2025 - 04.05.2025", price: "400 PLN" },
//         { term: "05.05.2025 - 27.06.2025", price: "270 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "450 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "500 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "450 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "270 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyt Boże Ciało cena 400 PLN/doba. Pobyty krótsze wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w Apartamecie za dopłatą 50 PLN/doba. Maksymalna ilość osób wynosi 8 (razem z dziećmi).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną i miejsce parkingowe.",
//         "Ceny nie zawierają opłaty za ewentualne ogrzewanie elektryczne – płatność za rzeczywiste zużycie według wskazań licznika."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Wynajem Domków Urszula Drużna",
//         numerRachunku: "70 1050 1924 1000 0092 3962 2898",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     },
//     domki: {
//       title: "Kolorowe Domki 4-6 osobowe",
//       table: [
//         { term: "01.06.2025 - 27.06.2025", price: "200 PLN" },
//         { term: "28.06.2025 - 11.07.2025", price: "350 PLN" },
//         { term: "12.07.2025 - 17.08.2025", price: "400 PLN" },
//         { term: "18.08.2025 - 31.08.2025", price: "350 PLN" },
//         { term: "01.09.2025 - 30.09.2025", price: "200 PLN" }
//       ],
//       notes: [
//         "Podane ceny obowiązują przy pobytach co najmniej 3 dniowych.",
//         "Pobyty krótsze oraz na Boże Ciało (300 PLN/doba) wyceniamy indywidualnie.",
//         "Każda dodatkowa osoba w domku za dopłatą 30 PLN/doba. Maksymalna ilość osób wynosi 6 (2 osoby dorosłe i reszta dzieci).",
//         "Opłata za małe zwierzęta (psy i koty) wynosi 20 PLN/doba."
//       ],
//       uwagi: [
//         "Ceny zawierają opłaty za wodę i prąd, opłatę klimatyczną oraz miejsce parkingowe."
//       ],
//       warunki: "Rezerwacje uważa się za potwierdzoną po wpłaceniu zaliczki w wysokości 3 dniowego pobytu w terminie 3 dni od dokonania rezerwacji telefonicznej lub e-mail. Pozostałą kwotę należy uiścić w dniu przyjazdu przy zameldowaniu.",
//       danePrzelewowe: {
//         nazwa: "Irena Drużna",
//         numerRachunku: "17 1050 1041 1000 0092 0616 4031",
//         tytulPrzelewu: "Imię i Nazwisko, termin pobytu i numer telefonu"
//       }
//     }
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchPricingData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/pricing.php?t=${Date.now()}`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych cennika');
//         }
        
//         const data = await response.json();
//         setPricingData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych cennika:', error);
//         //setError('Nie udało się załadować danych cennika. Wyświetlam domyślną zawartość.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPricingData();

//     // // Sprawdzaj zmiany co 10 sekund
//     // const interval = setInterval(fetchPricingData, 10000);
//     // return () => clearInterval(interval);
//   }, []);

//   const renderPricingSection = (section, sectionKey) => {
//     if (!section || !section.table || section.table.length === 0) {
//       return null;
//     }

//     return (
//       <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
//         <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
//           {section.title || "Cennik"}
//         </h2>
        
//         <div className="overflow-x-auto mb-8">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="bg-yellow-50">
//                 <th className="p-4 text-left border-b border-yellow-200">Termin</th>
//                 <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {section.table.map((row, index) => (
//                 <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">{row.term || "Termin"}</td>
//                   <td className="p-4 text-right font-medium">{row.price || "Cena"}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="space-y-4 text-gray-700">
//           {section.notes && section.notes.length > 0 && (
//             <>
//               {section.notes.map((note, index) => (
//                 <p key={index}>{note}</p>
//               ))}
//             </>
//           )}
          
//           {section.uwagi && section.uwagi.length > 0 && (
//             <div className="mt-6 space-y-2">
//               <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
//               <ul className="list-disc pl-5 space-y-1">
//                 {section.uwagi.map((uwaga, index) => (
//                   <li key={index}>{uwaga}</li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {section.warunki && (
//             <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
//               <p>{section.warunki}</p>
//             </div>
//           )}

//           {section.danePrzelewowe && (
//             <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
//               <p className="font-medium">{section.danePrzelewowe.nazwa || "Nazwa odbiorcy"}</p>
//               <p>Numer rachunku: <span className="font-mono">{section.danePrzelewowe.numerRachunku || "Numer rachunku"}</span></p>
//               <p>W tytule przelewu proszę wpisać: <span className="font-medium">{section.danePrzelewowe.tytulPrzelewu || "Tytuł przelewu"}</span></p>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <section className="py-16 bg-[#edece8]">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="py-16 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         {/* Komunikat o błędzie */}
//         {error && (
//           <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//             {error}
//           </div>
//         )}
        
//         <h1 className="text-4xl font-bold text-center mb-12 text-yellow-600">
//           {pricingData.title || "Cennik"}
//         </h1>
        
//         {pricingData.apartamenty && renderPricingSection(pricingData.apartamenty, 'apartamenty')}
//         {pricingData.domki && renderPricingSection(pricingData.domki, 'domki')}
        
//         {/* Komunikat gdy brak danych */}
//         {(!pricingData.apartamenty && !pricingData.domki) && (
//           <div className="text-center py-12">
//             <p className="text-gray-500 text-xl">Brak dostępnych danych cennika</p>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default Pricing;

// import React, { useState, useEffect } from 'react';

// const Pricing = () => {
//   const API_BASE = '/api/content';
  
//   const [pricingData, setPricingData] = useState({
//     title: "Cennik",
//     apartamenty: {
//       title: "Apartamenty Kolorowe Domki 4-8 osobowe",
//       table: [],
//       notes: [],
//       uwagi: [],
//       warunki: "",
//       danePrzelewowe: {
//         nazwa: "",
//         numerRachunku: "",
//         tytulPrzelewu: ""
//       }
//     },
//     domki: {
//       title: "Kolorowe Domki 4-6 osobowe",
//       table: [],
//       notes: [],
//       uwagi: [],
//       warunki: "",
//       danePrzelewowe: {
//         nazwa: "",
//         numerRachunku: "",
//         tytulPrzelewu: ""
//       }
//     }
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchPricingData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/get-pricing.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych cennika');
//         }
        
//         const data = await response.json();
//         setPricingData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych cennika:', error);
//         setError('Nie udało się załadować danych cennika. Wyświetlam domyślną zawartość.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPricingData();
//   }, []);

//   const renderPricingSection = (section, sectionKey) => {
//     if (!section || !section.table || section.table.length === 0) {
//       return null;
//     }

//     return (
//       <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
//         <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
//           {section.title || "Cennik"}
//         </h2>
        
//         <div className="overflow-x-auto mb-8">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="bg-yellow-50">
//                 <th className="p-4 text-left border-b border-yellow-200">Termin</th>
//                 <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {section.table.map((row, index) => (
//                 <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">{row.term || "Termin"}</td>
//                   <td className="p-4 text-right font-medium">{row.price || "Cena"}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="space-y-4 text-gray-700">
//           {section.notes && section.notes.length > 0 && (
//             <>
//               {section.notes.map((note, index) => (
//                 <p key={index}>{note}</p>
//               ))}
//             </>
//           )}
          
//           {section.uwagi && section.uwagi.length > 0 && (
//             <div className="mt-6 space-y-2">
//               <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
//               <ul className="list-disc pl-5 space-y-1">
//                 {section.uwagi.map((uwaga, index) => (
//                   <li key={index}>{uwaga}</li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {section.warunki && (
//             <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
//               <p>{section.warunki}</p>
//             </div>
//           )}

//           {section.danePrzelewowe && section.danePrzelewowe.nazwa && (
//             <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
//               <p className="font-medium">{section.danePrzelewowe.nazwa}</p>
//               <p>Numer rachunku: <span className="font-mono">{section.danePrzelewowe.numerRachunku}</span></p>
//               <p>W tytule przelewu proszę wpisać: <span className="font-medium">{section.danePrzelewowe.tytulPrzelewu}</span></p>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <section className="py-16 bg-[#edece8]">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="py-16 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         {/* Komunikat o błędzie */}
//         {error && (
//           <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//             {error}
//           </div>
//         )}
        
//         <h1 className="text-4xl font-bold text-center mb-12 text-yellow-600">
//           {pricingData.title || "Cennik"}
//         </h1>
        
//         {pricingData.apartamenty && renderPricingSection(pricingData.apartamenty, 'apartamenty')}
//         {pricingData.domki && renderPricingSection(pricingData.domki, 'domki')}
        
//         {/* Komunikat gdy brak danych */}
//         {(!pricingData.apartamenty?.table?.length && !pricingData.domki?.table?.length) && (
//           <div className="text-center py-12">
//             <p className="text-gray-500 text-xl">Brak dostępnych danych cennika</p>
//             <p className="text-gray-400 mt-2">Zaloguj się do panelu administracyjnego, aby dodać dane cennika</p>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default Pricing;

// import React, { useState, useEffect } from 'react';

// const Pricing = () => {
//   const API_BASE = '/api/content';
  
//   const [pricingData, setPricingData] = useState({
//     title: "Cennik",
//     apartamenty: {
//       title: "Apartamenty Kolorowe Domki 4-8 osobowe", 
//       table: [],
//       notes: [],
//       uwagi: [],
//       warunki: "",
//       danePrzelewowe: {
//         nazwa: "",
//         numerRachunku: "",
//         tytulPrzelewu: ""
//       }
//     },
//     domki: {
//       title: "Kolorowe Domki 4-6 osobowe",
//       table: [],
//       notes: [],
//       uwagi: [],
//       warunki: "",
//       danePrzelewowe: {
//         nazwa: "",
//         numerRachunku: "",
//         tytulPrzelewu: ""
//       }
//     }
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchPricingData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/get-pricing.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych cennika');
//         }
        
//         const data = await response.json();
//         setPricingData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych cennika:', error);
//         setError('Nie udało się załadować danych cennika');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPricingData();
//   }, []);

//   const renderPricingSection = (section, sectionKey) => {
//     if (!section || !section.table || section.table.length === 0) {
//       return null;
//     }

//     return (
//       <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
//         <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
//           {section.title || "Cennik"}
//         </h2>
        
//         <div className="overflow-x-auto mb-8">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="bg-yellow-50">
//                 <th className="p-4 text-left border-b border-yellow-200">Termin</th>
//                 <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {section.table.map((row, index) => (
//                 <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
//                   <td className="p-4">{row.term || "Termin"}</td>
//                   <td className="p-4 text-right font-medium">{row.price || "Cena"}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="space-y-4 text-gray-700">
//           {section.notes && section.notes.length > 0 && (
//             <>
//               {section.notes.map((note, index) => (
//                 <p key={index}>{note}</p>
//               ))}
//             </>
//           )}
          
//           {section.uwagi && section.uwagi.length > 0 && (
//             <div className="mt-6 space-y-2">
//               <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
//               <ul className="list-disc pl-5 space-y-1">
//                 {section.uwagi.map((uwaga, index) => (
//                   <li key={index}>{uwaga}</li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {section.warunki && (
//             <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
//               <p>{section.warunki}</p>
//             </div>
//           )}

//           {section.danePrzelewowe && section.danePrzelewowe.nazwa && (
//             <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
//               <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
//               <p className="font-medium">{section.danePrzelewowe.nazwa}</p>
//               <p>Numer rachunku: <span className="font-mono">{section.danePrzelewowe.numerRachunku}</span></p>
//               <p>W tytule przelewu proszę wpisać: <span className="font-medium">{section.danePrzelewowe.tytulPrzelewu}</span></p>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <section className="py-16 bg-[#edece8]">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="py-16 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         {error && (
//           <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//             {error}
//           </div>
//         )}
        
//         <h1 className="text-4xl font-bold text-center mb-12 text-yellow-600">
//           {pricingData.title || "Cennik"}
//         </h1>
        
//         {pricingData.apartamenty && renderPricingSection(pricingData.apartamenty, 'apartamenty')}
//         {pricingData.domki && renderPricingSection(pricingData.domki, 'domki')}
//       </div>
//     </section>
//   );
// };

// export default Pricing;

import React, { useState, useEffect } from 'react';

const Pricing = () => {
  const API_BASE = '/api/content';
  
  const [pricingData, setPricingData] = useState({
    title: "Cennik",
    apartamenty: {
      title: "Apartamenty Kolorowe Domki 4-8 osobowe", 
      table: [],
      notes: [],
      uwagi: [],
      warunki: "",
      danePrzelewowe: {
        nazwa: "",
        numerRachunku: "",
        tytulPrzelewu: ""
      }
    },
    domki: {
      title: "Kolorowe Domki 4-6 osobowe",
      table: [],
      notes: [],
      uwagi: [],
      warunki: "",
      danePrzelewowe: {
        nazwa: "",
        numerRachunku: "",
        tytulPrzelewu: ""
      }
    },
    regulamin: {
      title: "",
      content: []
    }
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Załaduj dane z serwera
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/get-pricing.php`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych cennika');
        }
        
        const data = await response.json();
        setPricingData(data);
      } catch (error) {
        console.error('Błąd ładowania danych cennika:', error);
        setError('Nie udało się załadować danych cennika');
      } finally {
        setLoading(false);
      }
    };

    fetchPricingData();
  }, []);

  const renderPricingSection = (section) => {
    if (!section || !section.table || section.table.length === 0) return null;

    return (
      <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          {section.title || "Cennik"}
        </h2>
        
        <div className="overflow-x-auto mb-8">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-yellow-50">
                <th className="p-4 text-left border-b border-yellow-200">Termin</th>
                <th className="p-4 text-right border-b border-yellow-200">Cena za dobę (do 4 osób)</th>
              </tr>
            </thead>
            <tbody>
              {section.table.map((row, index) => (
                <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="p-4">{row.term || "Termin"}</td>
                  <td className="p-4 text-right font-medium">{row.price || "Cena"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="space-y-4 text-gray-700">
          {section.notes?.length > 0 && section.notes.map((note, index) => <p key={index}>{note}</p>)}
          
          {section.uwagi?.length > 0 && (
            <div className="mt-6 space-y-2">
              <h3 className="text-xl font-semibold text-gray-800">Uwagi:</h3>
              <ul className="list-disc pl-5 space-y-1">
                {section.uwagi.map((uwaga, index) => <li key={index}>{uwaga}</li>)}
              </ul>
            </div>
          )}

          {section.warunki && (
            <div className="mt-6 space-y-2 bg-yellow-50 p-4 rounded-lg">
              <h3 className="text-xl font-semibold text-gray-800">Warunki rezerwacji:</h3>
              <p>{section.warunki}</p>
            </div>
          )}

          {section.danePrzelewowe?.nazwa && (
            <div className="mt-6 space-y-2 bg-blue-50 p-4 rounded-lg">
              <h3 className="text-xl font-semibold text-gray-800">Dane do przelewów:</h3>
              <p className="font-medium">{section.danePrzelewowe.nazwa}</p>
              <p>Numer rachunku: <span className="font-mono">{section.danePrzelewowe.numerRachunku}</span></p>
              <p>W tytule przelewu proszę wpisać: <span className="font-medium">{section.danePrzelewowe.tytulPrzelewu}</span></p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderRegulamin = (regulamin) => {
    if (!regulamin?.content?.length) return null;

    return (
      <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          {regulamin.title || "Regulamin"}
        </h2>
        <ol className="list-decimal list-inside space-y-2 text-gray-700">
          {regulamin.content.map((item, index) => <li key={index}>{item}</li>)}
        </ol>
      </div>
    );
  };

  if (loading) {
    return (
      <section className="py-16 bg-[#edece8]">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-[#edece8]">
      <div className="max-w-6xl mx-auto px-4">
        {error && (
          <div className="mb-6 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
            {error}
          </div>
        )}
        
        <h1 className="text-4xl font-bold text-center mb-12 text-yellow-600">
          {pricingData.title || "Cennik"}
        </h1>
        
        {renderPricingSection(pricingData.apartamenty)}
        {renderPricingSection(pricingData.domki)}
        {renderRegulamin(pricingData.regulamin)}
      </div>
    </section>
  );
};

export default Pricing;